import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const OutlinedTickCircleSolid = forwardRef<SVGSVGElement, IconProps>(function OutlinedTickCircleSolid(
  { color = '#68617B', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2072_338093)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 6.85144C0 3.55054 2.6991 0.85144 6 0.85144C9.3009 0.85144 12 3.55054 12 6.85144C12 10.1523 9.3009 12.8514 6 12.8514C2.6991 12.8514 0 10.1523 0 6.85144ZM6 1.63649C3.13267 1.63649 0.785047 3.98411 0.785047 6.85144C0.785047 9.71877 3.13267 12.0664 6 12.0664C8.86733 12.0664 11.215 9.71877 11.215 6.85144C11.215 3.98411 8.86733 1.63649 6 1.63649Z"
          fill={color || 'currentColor'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.66098 4.9872C8.81413 5.14063 8.81391 5.38916 8.66049 5.54232L5.48105 8.71615C5.32772 8.86921 5.07938 8.8691 4.92618 8.7159L3.33927 7.12899C3.18598 6.9757 3.18598 6.72716 3.33927 6.57387C3.49256 6.42058 3.74109 6.42058 3.89438 6.57387L5.20398 7.88348L8.10587 4.98671C8.25929 4.83356 8.50782 4.83378 8.66098 4.9872Z"
          fill={color || 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2072_338093">
          <rect width="12" height="12" fill={color || 'currentColor'} transform="translate(0 0.85144)" />
        </clipPath>
      </defs>
    </svg>
  );
});
